import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { JService, refreshAccessToken } from "../api-service/ApiService";
import { saveAccountDetails } from "../features/account/account";
import { login } from "../features/user/user";
import { enqueueSnackbar } from "notistack";
import { CustomSelect } from "../design/components/customComponents";
import Button from "../design/Button";
import vectorArt from "../../assets/signup-screen2.svg";
import dotsBottom from "../../assets/login-dots-bottom.svg";
import dotsTop from "../../assets/login-dots-top.svg";
import logo from "../../assets/top-nav-logo.svg";
import './SignupAccountType.css';
import { useNavigate } from "react-router-dom";
import TrialCard from "../design/components/TrialCard";
import { fetchAccountProfile } from "../../utility-functions";

const accountTypeOptions = [
  { value: "INR Account", displayValue: "INR Account" },
  { value: "USD Account", displayValue: "USD Account" },
];

const SignupAccountType = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userLoginAttemptWith = useSelector((state) => state.user.value);
  const [accountType, setAccountType] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [trialType, setTrialType] = useState("UNRESTRICTED");

  const handleInitiateTrial = async (e) => {
    try {
      e.preventDefault();
      if (!accountType) return;
      setIsLoading(true);
      const response = await JService.post(
        "/api/v1/subscriptions/initiate-trial/",
        JSON.stringify({ account_type: accountType, trial_type: trialType })
      );
      if (!response?.success)
        throw new Error(response?.message || "Failed to initiate trial");
      
      if (trialType === "RESTRICTED") {
        setTimeout(async () => {
          await fetch_account_profile();
          await refreshAccessToken();
          console.log("calling dispatch(login)");
          dispatch(login({ ...userLoginAttemptWith, source: "signup" }));
        }, 5000);
      } else {
        const response = await JService.post(
          "/api/v1/integrations/kyc/initiate",
        );
        navigate("/signup/kyc", {
          state: {
            session_id: response.session_id,
            secureme_link: response.secureme_link
          }
        });
        console.log("kyc response: ", response);
      }
    } catch (err) {
      enqueueSnackbar(err?.message, { variant: "error" });
      setIsLoading(false);
    } finally {
      if (trialType === "RESTRICTED") {
        setTimeout(() => {
          setIsLoading(false);
        }, 5500); // 500 ms extra to give enough room for profile fetching, storing etc
      }else {
        setIsLoading(false);
      }
    }
  };

  const fetch_account_profile = async () => {
      const response = await fetchAccountProfile();
      if (response)
        dispatch(saveAccountDetails(response));
  };

  return (
    <div className="signup-screen-container">
      <div className="signup-art">
        <a href="https://frejun.com/" target="_blank" rel="noopener noreferrer">
          {" "}
          <img src={logo} alt="Logo" />
        </a>
        <img src={dotsTop} />
        <img src={vectorArt} />
        <img src={dotsBottom} />
      </div>
      <div className="signup-screen2-form">
        <p className="title medium-font t5">Almost there!</p>
        <form className="signup-account-type--form">
          <div className="select-container">
            <CustomSelect
              label="Account type"
              value={accountType}
              handleChange={(e) => setAccountType(e.target.value)}
              options={accountTypeOptions}
            />
          </div>

          <div className="select-container">
            <label className="trial-label title t5 medium-font">Trial type</label>

            <div className="trial-options" role="radiogroup" aria-label="Trial type">
              <TrialCard
                value="RESTRICTED"
                name="trialType"
                title="Instant Trial"
                subtitle="Perfect for testing the dashboard and inbound flows."
                selected={trialType === "RESTRICTED"}
                onChange={(e) => setTrialType(e.target.value)}
              >
                <ul className="trial-list">
                  <li>Receive calls from any number immediately.</li>
                  <li>Outgoing calls limited to your registered phone number.</li>
                </ul>
              </TrialCard>

              <TrialCard
                value="UNRESTRICTED"
                name="trialType"
                title="Unrestricted Trial"
                subtitle="Full access for live business operations."
                selected={trialType === "UNRESTRICTED"}
                onChange={(e) => setTrialType(e.target.value)}
              >
                <ul className="trial-list">
                  <li>Make and receive calls without restrictions.</li>
                  <li>Complete a quick KYC check to unlock outgoing calls.</li>
                </ul>
              </TrialCard>
            </div>
          </div>
          <div>
            <Button
              variant="contained"
              hierarchy="green"
              buttonText="Next"
              onClick={handleInitiateTrial}
              disabled={!accountType}
              isLoading={isLoading}
              styleOverride={{
                padding: '8px 40px',
                width: "100%"
              }}
              spanStyles={{ Width: '100%' }}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default SignupAccountType;
